import { render, staticRenderFns } from "./NoticeDownload.vue?vue&type=template&id=b9f23942&scoped=true"
import script from "./NoticeDownload.vue?vue&type=script&lang=js"
export * from "./NoticeDownload.vue?vue&type=script&lang=js"
import style0 from "./NoticeDownload.vue?vue&type=style&index=0&id=b9f23942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f23942",
  null
  
)

export default component.exports